import { BaseModel } from "../base.model";

export class MasterPaymentModel extends BaseModel {
    auto_id?:number;
    ipgType:any;
    iaad_id:any;
    ia_id:any;
    ia_parent:any;
    ips_id:any;
    ips_name:any;
    ips_year:any;
    ips_month:any;
    ia_created_date:any;
    ia_status_name:any;
    kgkPermohonan:any;
    beratKeringDibayar:any;
    NilaiPermohonan:any;
    amaunDibayar:any;
    tarikhDibayar:any;
    rt_id:any;
    jenisGetah:any;
    ia_isErd:any;
    ia_notes:any;
    ia_member:any;
    membername:any;
    memberic:any;
    memberactive:any;
    ia_card:any;
    cardno:any;
    cardactive:any;
    cardInProcess:any;
    stateIdCard:any;
    stateNameCard:any;
    districtIdCard:any;
    districtNameCard:any;
    subDivIdCard:any;
    subDivNameCard:any;
    subDivParlimen:any;
    subDivDun:any;
    as_id:any;
    as_name:any;
    agencyId:any;
    agencyName:any;
    officeId:any;
    officeName:any;
    ia_status:any;
    iaa_status:any;
    ib_id:any;
    iaa_id:any;
    bankfilename:any;
    ia_bankRemark:any;
    ia_bankRemarkOri:any;
    ibc_id:any;
    ibc_amount:any;
    ibc_new_app:any;
    ibc_kgk_total:any;
    ibc_amount_allowed:any;
    ibc_kgk_allowed:any;
    SubCatName:any;
    cardId:any;
    ia_folio:any;
    ia_no:any;
    ia_phone:any;
    ia_bankname:any;
    ia_accountno:any;
    cardTotalFarmHectare:any;
}